














import {Component,Vue,Watch} from "vue-property-decorator";
import {mapGetters} from "vuex";
import LoggedIn from "@/components/Logged-in.vue";
import LoggedInSidebar from "@/components/Logged-in.vue";
import LoggedOut from "@/components/Logged-out.vue";
import {bool} from "aws-sdk/clients/signer";
import {Route} from "vue-router";

@Component({
  components:{
    LoggedIn,
    LoggedInSidebar,
    LoggedOut,
  },
  computed:
          mapGetters({
            pageTitle: 'title/pageTitle',
            isPublic: 'status/isPublic',
            isSidebarHidden: 'status/isSidebarHidden'
          }),
})
export default class App extends Vue {
  mounted(): void {
    const to = this.$route;
    this.changePageTitle(to);
  }

  @Watch('$route')
  pageChanged(to: Route, from: Route){
    this.changePageTitle(to);
  }

  public changePageTitle(to: Route){
    if(to.meta.title){
      const setTitle = to.meta.title + ' | pluscomm mypage';
      document.title = setTitle;
    } else {
      document.title = 'pluscomm mypage'
    }
  }
}
